$(function () {
    'use strict';
    var submitButton = $('#btn-send');

    function commonshow() {
        $('#schedule').show();
        $('.recipientsselect').show();
        $('#type option:first').prop('selected', true);
        $('#typehelper').empty();
    }

    function emailonlyshow() {
        window.mode = 'EMAIL';
        commonshow();
        $('#email-only').fadeIn();
        $('#Subject').fadeIn();
        $('#toggle_file_code').fadeIn();
        $('#advance-options-rollup').fadeIn();
        $('#tabs-only-email').fadeIn();
        $('#tabs-only-sms').fadeOut();
        $('#tabs-only-notification').fadeOut();
        $('#tabs-only-emailtimetable').fadeOut();
        $('#main').fadeIn();
        $('#btn-preview').hide();
        $('#btn-testemail').show();
        $(submitButton).html('<i class="' + FontAwesome.prefix('regular', 'envelope') + '"></i>Send Email');
        $('input[name="recipients[]"]').css('display:none;');
    }

    function bothshow() {
        window.mode = 'BOTH';
        commonshow();
        $('#tabbable').fadeOut();
        $('#tabs-only-sms').fadeIn();
        $('#Subject').fadeIn();
        $('#toggle_file_code').fadeIn();
        $('#advance-options-rollup').fadeIn();
        $('#tabbable').fadeOut();
        $('#email-only').fadeIn();
        $('#tabs-only-email').fadeIn();
        $('#tabs-only-notification').fadeOut();
        $('#tabs-only-emailtimetable').fadeOut();
        $('#main').fadeIn();
        $('#btn-preview').hide();
        $(submitButton).html('<i class="' + FontAwesome.prefix('regular', 'envelope') + '"></i>Send Email + SMS');
        $('input[name="recipients[]"]').css('display:none;');
    }

    function smsonlyshow() {
        window.mode = 'SMS';
        commonshow();
        $('#email-only').fadeOut();
        $('#tabs-only-sms').fadeIn();
        $('#tabs-only-email').fadeOut();
        $('#tabs-only-notification').fadeOut();
        $('#tabs-only-emailtimetable').fadeOut();
        $('#Subject').fadeOut();
        $('#advance-options-rollup').fadeOut();
        $('#toggle_file_code').fadeOut();
        $('#main').fadeIn();
        $('#btn-preview').hide();
        $('#btn-testemail').hide();
        $(submitButton).html('<i class="' + FontAwesome.prefix('regular', 'envelope') + '"></i>Send SMS');
        $('input[name="recipients[]"]').css('display:none;');
    }

    function notificationonlyshow() {
        window.mode = 'NOTIFICATION';
        commonshow();
        $('#expiry').fadeIn();
        $('#email-only').fadeOut();
        $('#Subject').fadeOut();
        $('#toggle_file_code').fadeOut();
        $('#advance-options-rollup').fadeOut();
        $('#tabs-only-email').fadeOut();
        $('#tabs-only-sms').fadeOut();
        $('#tabs-only-notification').fadeIn();
        $('#tabs-only-emailtimetable').fadeOut();
        $('#main').fadeIn();
        $('#btn-preview').hide();
        $('#btn-testemail').hide();
        $(submitButton).html('<i class="' + FontAwesome.prefix('regular', 'sticky-note') + '"></i>Post Notification');
        $('input[name="recipients[]"]').css('display:none;');
    }

    function emailtimetableonlyshow() {
        window.mode = 'EMAILTIMETABLE';
        $('.recipientsselect').hide();
        $('#expiry').fadeIn();
        $('#email-only').fadeOut();
        $('#Subject').fadeOut();
        $('#toggle_file_code').fadeOut();
        $('#advance-options-rollup').fadeOut();
        $('#tabs-only-email').fadeOut();
        $('#tabs-only-sms').fadeOut();
        $('#tabs-only-notification').fadeOut();
        $('#tabs-only-emailtimetable').fadeIn();
        $('#main').fadeIn();
        $('#btn-preview').fadeIn();
        $('#btn-testemail').hide();
        $(submitButton).html('<i class="' + FontAwesome.prefix('regular', 'envelope') + '"></i>Send Email to Lecturers');
    }

    $('input[name="customreplyto"]').on('blur', function () {
        var custom  = $('#customreplyto').val();
        var replyto = $('#msgreplyto').html();
        replyto = replyto + '<option value="' + custom + '" selected>' + custom + '</option>';
        $('#msgreplyto').html(replyto);
        $('#msgreplytofriendly').val(custom);
        $('input[name="msgcc"]').val(custom);
        $('#customreplytoaddress').toggle();
    });

    function calculateTotalUploadPercentage() {
        var totalUploadedFilesSize        = 0; // Size of all the files due to be uploaded (in bytes)
        var totalUploadedFilesSizePercent = 0; // Percentage of 10MB that the combined file sizes take up
        var limit                         = 10485760; // 10 megs
        var fileSizePercent               = $('#file-size-percent');

        $.each($('#file-list').find('input[type="file"]:not(.file-upload-template)'), function (idx, val) {
            if (val.files !== undefined && $(val).val() !== '') {
                var file = val.files[0];
                totalUploadedFilesSize += file.size;
            }
        });

        totalUploadedFilesSizePercent = totalUploadedFilesSize / limit * 100;
        if (totalUploadedFilesSizePercent > 100) {
            $(fileSizePercent).addClass('progress-bar-danger');
            $(fileSizePercent).removeClass('progress-bar-warning');
            if (totalUploadedFilesSizePercent > 100) {
                Alert.error('Attachment Size Too Large',
                    'The file(s) you are trying to attach exceed the the ' + File.getReadableFileSizeString(limit) + ' limit.<br>' +
                    'Please consider reducing the size of your attachments and re-uploading. <br><br>' +
                    '<button type="button" class="btn btn-danger" data-toggle="modal" data-target="#filesizehelper"><i class="' + FontAwesome.prefix('solid', 'info') + '"></i>More Information</button>');
            }
            totalUploadedFilesSizePercent = 100;
        } else if (totalUploadedFilesSizePercent >= 80 && totalUploadedFilesSizePercent < 100) {
            $(fileSizePercent).removeClass('progress-bar-danger');
            $(fileSizePercent).addClass('progress-bar-warning');
        } else {
            $(fileSizePercent).removeClass('progress-bar-danger');
            $(fileSizePercent).removeClass('progress-bar-warning');
        }
        $(fileSizePercent).css('width', totalUploadedFilesSizePercent + '%');
        if (totalUploadedFilesSizePercent > 0) {
            $(fileSizePercent).text(File.getReadableFileSizeString(totalUploadedFilesSize) + ' of ' + File.getReadableFileSizeString(limit));
        } else {
            $(fileSizePercent).text('');
        }
        if (totalUploadedFilesSize > 0) {
            $(fileSizePercent).parent().fadeIn();
            $('#no-attachment-warning').fadeOut();
        } else {
            $(fileSizePercent).parent().fadeOut();
            $('#no-attachment-warning').fadeIn();
        }
        $(fileSizePercent).prop('aria-valuenow', totalUploadedFilesSizePercent);
    }

    // Handles the specific selection of users from a chosen group
    var massmailergroup      = $('#massmailergroup');
    var massmailergroupusers = $('#massmailergroupusers');
    var massmailerecipients  = $('#massmailer-recipients');
    var btnselectgroup       = $('#btn-selectgroup');
    var ajaxloading          = $('.ajaxloading');

    massmailergroup.add(massmailerecipients)
        .select2({
            width: '100%',
            theme: 'bootstrap',
            minimumInputLength: 3,
            ajax: {
                url: base_url + 'massmailer/ajax_recipients',
                dataType: 'json',
                delay: 250,
                type: 'GET',
                data: function (params) {
                    var queryParameters = {
                        term: params.term,
                    };
                    return queryParameters;
                },
                processResults: function (data) {
                    return {
                        results: $.map(data, function (item) {
                            var acyr           = item.acyr;
                            var typeIdentifier = '';
                            var type           = '';
                            var titleattr      = '';

                            if (item.type === 1) {
                                typeIdentifier = 'U';
                                type           = item.basicrole === 'basic' ? 'Student' : 'Staff';
                                titleattr      = item.name + ' (' + item.email + ')';
                            } else {
                                typeIdentifier = 'G';
                                type           = 'Group';
                                titleattr      = item.name;
                            }

                            return {
                                title: titleattr,
                                id: typeIdentifier + '|' + item.id,
                                text: item.name + ' (' + type + ')' + (acyr ? ' (' + acyr + ')' : ''),
                                // Workaround for Select2 4.1.0 Ajax search issue (GitHub issue #6423)
                                _resultId: 'mail-recipients-result-' + item.id,
                            };
                        }),
                    };
                },
            },
            templateSelection: function (item) {
                return item.text;
            },
        });
    massmailergroup.on('select2:select', function () {
        var groupid   = $(this).find('option:selected').val().substring(2);
        var groupname = $(this).find('option:selected').attr('title');

        $.ajax({
            type: 'GET',
            url: base_url + 'massmailer/ajax_users',
            data: { massmailergroup: groupid },
            dataType: 'json',
            beforeSend: function () {
                $(ajaxloading).html('<i class="' + FontAwesome.prefix('solid', 'spinner', true) + '"></i> Loading Group Users...');
            },
            success: function (users) {
                ajaxloading.empty();
                btnselectgroup.show();
                massmailergroup.append('<option value="' + groupid + '" selected="selected" title="' + groupname + ' ">' + groupname + '</option>');

                var students_html = $.map(users, function (user) {
                    return '<li><input type="checkbox" id="' + user.email + '" name="users[]" title="' + user.name + ' (' + user.email + ')" value="' + user.id + '" /> <label role="button" for="' + user.email + '">' + user.name + ' (' + user.email + ')</label></li>';
                }).join('');

                massmailergroupusers.empty()
                    .append('<li><input type="checkbox" role="button" id="select_all_checkboxes" class="select_all" /> <strong><label for="select_all_checkboxes" role="button">Select all students (' + users.length + ')</label></strong></li>')
                    .append(students_html);
            },
            complete: function () {
                btnselectgroup.show();
            },
        });
    });

    btnselectgroup.hide()
        .on('click', function () {
            // Clear the recipient field of year group when selecting users from same group within filter
            $('#massmailer-recipients option:selected').each(function () {
                if (massmailergroup.val() === $(this).val().substring(2)) {
                    $(this).remove();
                }
            });

            // Then populate recipient field with those users selected only
            $.each($('input[name=\'users[]\']:checked'), function () {
                massmailerecipients.append('<option value="U|' + $(this).val() + '" selected="selected" title="' + $(this).attr('title') + ' ">' + $(this).attr('title') + '</option>');
            });
            // Reset modal form elements and close
            massmailergroup.val('')
                .trigger('change');
            massmailergroupusers.empty();
            btnselectgroup.hide();
            $('#selectgroups').modal('hide');
        });

    $('.add-upload').on('click', function () {
        var templateFileUploadButton = $('.file-upload-template'); // The base template that we clone to generate the list items
        var filesContainer = $(templateFileUploadButton).parents('ul'); // The list containing all the list items with all the file inputs and other stuff in
        var uploadButtonCopyContainer = $(templateFileUploadButton).parent().clone(); // The parent li element containing the file upload as well as a red x to remove the file
        var newUploadButton = uploadButtonCopyContainer.children('input[type="file"]');

        // Change the name attribute
        newUploadButton.attr('name', 'file[]');
        newUploadButton.prop('disabled', false);

        // Stamp out the template into the list
        $(newUploadButton).removeClass('file-upload-template');
        $(uploadButtonCopyContainer).appendTo(filesContainer).show();

        // Register event listener for change...
        $(newUploadButton).on('change', function () {
            var file = $(this)[0].files[0];
            $(this).hide();
            $(this).parent().append('<p><i class="' + File.getIcon(file.name.split('.', 2)[1]) + '"></i> ' + file.name + ' <span class="small">' + File.getReadableFileSizeString(file.size) + '</span></p>');
            calculateTotalUploadPercentage();
        });

        $(uploadButtonCopyContainer).find('.remove-upload').on('click', function () {
            $(this).parent('li').remove();
            calculateTotalUploadPercentage();
        });
    });

    $('#email').on('click', function (event) {
        emailonlyshow();
        event.preventDefault();
    });

    $('#both').on('click', function (event) {
        bothshow();
        event.preventDefault();
    });

    $('#sms').on('click', function (event) {
        smsonlyshow();
        event.preventDefault();
    });

    $('#notification').on('click', function (event) {
        notificationonlyshow();
        event.preventDefault();
    });

    $('#emailtimetable').on('click', function (event) {
        emailtimetableonlyshow();
        event.preventDefault();
    });

    $('#email, #sms, #both, #notification, #emailtimetable').on('click', function () {
        var ul = $(this).closest('ul');
        ul.find('li').removeClass('active');
        $(this).closest('li').addClass('active');
    });

    $('#type').on('change', function () {
        if ($(this).val() === 'sitemsg') {
            $('#typehelper').html('<p class="help-block">Note: A site message will go out to ALL system users</p>');
            $('.recipientsselect').slideUp();
        } else if ($(this).val() === 'adminSitemsg') {
            $('#typehelper').html('<p class="help-block">Note: A site message for non-student system users</p>');
            $('.recipientsselect').slideUp();
        } else {
            $('#typehelper').empty();
            $('.recipientsselect').slideDown();
        }
    });

    function enableTestButton() {
        $('#btn-testemail').prop('disabled', false).html('<i class="' + FontAwesome.prefix('regular', 'envelope') + '"></i>Send Test Email');
    }

    function disableTestButton() {
        $('#btn-testemail').prop('disabled', true);
    }

    disableTestButton();

    $('#communicationsform').on('keyup change', function () {
        if ($('#massmailer-recipients option:selected').length < 1 || $('#subject').val().length < 12 || $('<div>').html($('#email-body_txtarea').summernote('code')).text().length < 12) {
            disableTestButton();
        } else {
            enableTestButton();
        }
    });

    $('#btn-testemail').on('click', function () {
        var testEmailData = $('#communicationsform').serializeArray();
        $.ajax({
            type: 'POST',
            url: 'massmailer/processform',
            cache: false,
            data: testEmailData,
            beforeSend: function () {
                disableTestButton();
                $('#btn-testemail').html('<i class="' + FontAwesome.prefix('regular', 'envelope') + '"></i>Sending...');
            },
            success: function (data) {
                enableTestButton();
                $('#test-email-msg').html('<i class="' + FontAwesome.prefix('solid', 'check') + '"></i> Test Email Sent').fadeIn('slow').delay(2000).fadeOut('slow');
            },
            error: function (err, status) {
                enableTestButton();
            },
        });
    });

    function eventConfirmationHide() {
        $('#event-confirmation-group').fadeOut();
        $('.event-confirmation-radio:checked').prop('checked', false);
        $('#event-confirmation-group').prop('disabled', true);
    }

    function eventConfirmationShow() {
        $('#event-confirmation-group').fadeIn();
        $('#all-confirmations').prop('checked', true);
        $('#event-confirmation-group').prop('disabled', false);
    }

    $('.event-status-radio').on('change', function () {
        var eventStatus = $('.event-status-radio:checked').val();

        if (eventStatus === 'unpublished') {
            eventConfirmationShow();
        } else {
            eventConfirmationHide();
        }
    });

    $('#tags').on('change', function () {
        // Check if a tag has been selected before enabling the preview button
        $('#btn-preview').prop('disabled', $(this).val().length === 0);
    });

    $('#lectureevents').on('show.bs.modal', function () {
        // Get existing lecturer selected and add ids to array, for populating checked state on checkboxes, should the user return to the modal for a 2nd preview.
        var arrayofexistinglectureids = new Set($('input[name="get_lecturers"]').val().split(','));

        var startdate         = $('#emailtimetable-startdate').val();
        var enddate           = $('#emailtimetable-enddate').val();
        var tags              = $('#tags').val();
        var emailsubject      = $('#emailtimetable-subject').val();
        var emailmessage      = $('#emailtimetable-body_txtarea').val();
        var sendername        = $('#sendername').val();
        var eventstatus       = $('.event-status-radio:checked').val();
        var eventconfirmation = $('.event-confirmation-radio:checked').val();

        $.ajax({
            type: 'GET',
            url: base_url + 'massmailer/ajax_getLectureEvents',
            data: { startdate: startdate, enddate: enddate, tags: tags, eventstatus: eventstatus, eventconfirmation: eventconfirmation },
            dataType: 'json',
            beforeSend: function () {
                $('#results').html('<i class="' + FontAwesome.prefix('solid', 'spinner', true) + '"></i> Searching Lecturers...');
            },
            success: function (data) {
                $('#results').empty();
                if (data.length > 0) {
                    var previewContent = '';
                    $.each(data, function (lecturerIndex, lecturer) {
                        // If lecturer has previously been selected, add checked state.
                        var checked = arrayofexistinglectureids.has(lecturer.id) ? 'checked' : '';
                        previewContent += '<label for="lecturer' + lecturer.id + '"><input type="checkbox" class="lecturers" name="lecturers[]" value="' + lecturer.id +
                            '" id="lecturer' + lecturer.id + '" data-fullname="' + lecturer.name + '" ' + checked + '> ' + lecturer.name +
                            ' (' + lecturer.email + ')' +
                            ' - ' + lecturer.eventlist.length + ' event(s)</label><br>';
                        // The first lecturer should show a true preview of the email that is recieved, with subject and message.
                        if (lecturerIndex == 0) {
                            previewContent += ' <strong>Subject: ' + emailsubject + ' </strong><br><br>Dear ' + lecturer.name.substr(0, lecturer.name.indexOf(' ')) +
                                '<br><br>' + emailmessage + '<br>Kind Regards,<br><br>' + sendername + '<br><br><strong>Timetable Events</strong><br>';
                        }
                        $.each(data[lecturerIndex].eventlist, function (eventIndex, timetableevent) {
                            // Loop through all timetable events for this lecturer.
                            var title    = data[lecturerIndex].eventlist[eventIndex].event_title;
                            var start    = data[lecturerIndex].eventlist[eventIndex].event_start;
                            var end      = data[lecturerIndex].eventlist[eventIndex].event_end;
                            var room     = data[lecturerIndex].eventlist[eventIndex].event_room ? data[lecturerIndex].eventlist[eventIndex].event_room : 'No room defined';
                            var building = data[lecturerIndex].eventlist[eventIndex].event_building ? data[lecturerIndex].eventlist[eventIndex].event_building : 'No building defined';

                            previewContent += title + ' <br> ' + start + ' - ' + end + '<br>' + room + ' ' + building + '<br><br>';
                        });
                        previewContent += '<hr />';
                    });
                    $('#results').append(previewContent);
                } else {
                    $('#results').html($('<div>', {
                        text: 'No lecturers for the criteria selected.',
                    }));
                }
            },
        });
    });

    // On save/dismiss of lecture events preview modal, get lecturers selected and post parent form.
    $(this).on('hide.bs.modal', function (e) {
        var selectedLecturer        = [];
        var selectedLecturerName    = [];
        var LecturerNameNotSelected = [];
        // Get lecturers selected
        if ($('.lecturers:checked').length > 0) {
            $('.lecturers:checked').each(function () {
                selectedLecturer.push($(this).val());
                selectedLecturerName.push($(this).data('fullname'));
            });
        } else {
            selectedLecturerName.length = 0;
        }
        // Get lecturers not selected
        if ($('.lecturers:checkbox:not(:checked)').length > 0) {
            $('.lecturers:checkbox:not(:checked)').each(function () {
                LecturerNameNotSelected.push($(this).data('fullname'));
            });
        } else {
            LecturerNameNotSelected.length = 0;
        }

        var getLecturers               = selectedLecturer.join(',');
        var getLecturersName           = selectedLecturerName.join(', ');
        var getLecturerNameNotSelected = '';

        if (LecturerNameNotSelected.length > 0) {
            getLecturerNameNotSelected = '<hr /><strong>Lecturers to be excluded:</strong> ' + LecturerNameNotSelected.join(', ');
        }

        $('#get_lecturers').attr('value', getLecturers);
        if (getLecturersName.length > 0) {
            $('.lecturernames').empty().append('<div class="alert alert-info" role="alert"><strong>Lecturers to receive email:</strong> ' + getLecturersName + getLecturerNameNotSelected + '</div>');
            $('html, body').animate({ scrollTop: 0 }, 'slow');
        } else {
            $('.lecturernames').empty();
        }

        $('#select_all_checkboxes').prop('checked', false);
    });

    var email_wysiwyg_editor = $('textarea[name="email-body_txtarea"]');
    var sms_wysiwyg_editor   = $('textarea[name="sms-body_txtarea"]');
    var sms_chars_remaining  = $('#charsleft');

    // Some custom buttons that we can use to drop placeholder text into our communications
    var placeholder_buttons = {
        title: function (context) {
            return $.summernote.ui.button({
                contents: '<i class="' + FontAwesome.prefix('regular', 'user') + '"></i>Title',
                tooltip: 'Insert user\'s title/salutation',
                click: function () {
                    context.invoke('editor.insertText', '%%TITLE%%');
                },
            }).render();
        },
        firstName: function (context) {
            return $.summernote.ui.button({
                contents: '<i class="' + FontAwesome.prefix('regular', 'user') + '"></i>First Name',
                tooltip: 'Insert user\'s forename',
                click: function () {
                    context.invoke('editor.insertText', '%%FIRSTNAME%%');
                },
            }).render();
        },
        lastName: function (context) {
            return $.summernote.ui.button({
                contents: '<i class="' + FontAwesome.prefix('regular', 'user') + '"></i>Last Name',
                tooltip: 'Insert user\'s surname',
                click: function () {
                    context.invoke('editor.insertText', '%%LASTNAME%%');
                },
            }).render();
        },
        fullName: function (context) {
            return $.summernote.ui.button({
                contents: '<i class="' + FontAwesome.prefix('regular', 'user') + '"></i>Full Name',
                tooltip: 'Insert user\'s full name',
                click: function () {
                    context.invoke('editor.insertText', '%%FULLNAME%%');
                },
            }).render();
        },
        idNumber: function (context) {
            return $.summernote.ui.button({
                contents: '<i class="' + FontAwesome.prefix('regular', 'user') + '"></i>ID Number',
                tooltip: 'Insert user\'s ID number',
                click: function () {
                    context.invoke('editor.insertText', '%%ID%%');
                },
            }).render();
        },
    };

    var placeholders_toolbar = [['placeholders', ['title', 'firstName', 'lastName', 'fullName', 'idNumber']]];

    email_wysiwyg_editor.summernote($.extend(default_options, {
        toolbar: default_options.toolbar.concat(placeholders_toolbar),
        buttons: placeholder_buttons,
    }));

    // Initalize our custom summernote instance for SMS composition
    sms_wysiwyg_editor.summernote($.extend(default_options, {
        toolbar: placeholders_toolbar,
        buttons: placeholder_buttons,
        callbacks: {
            onChange: function (contents) {
                var max = 160;
                var length = $('<span />').html(contents).text().length;
                sms_chars_remaining.text(max - length);

                if (length > max) {
                    $(sms_chars_remaining).addClass('text-danger');
                    $('button#btn-send').attr('disabled', true);
                } else {
                    $(sms_chars_remaining).removeClass('text-danger');
                    $('button#btn-send').removeAttr('disabled');
                }
            },
        },
    }));

    emailonlyshow();

    var $msgcc   = $('#msgcc');
    var userData = $msgcc.data('user');

    // Add the default user to the carbon copy email field
    var newOption = new Option(userData, userData, true, true);
    $msgcc.prepend(newOption).trigger('change');
});
